import styled from '@emotion/styled';

export default styled.div`
    .layout-html-styled-content.description {
        text-align: center;
        font-size: 16px;
        word-break: break-word;
        margin-top: 0 !important;

        div {
            p {
                margin-bottom: 20px;
                line-height: 20px !important;

                span {
                    line-height: 20px !important;
                }
            }
        }
    }

    .layout-container {
        .public-layout-description {
            .headline {
                h3 {
                    word-break: break-word;
                }

                margin-bottom: 1em;
            }

            .description-wrapper {
                max-height: 120px;
                overflow: hidden;

                &.expandable {
                    margin-bottom: 2em;
                }

                &.expanded {
                    max-height: 100%;
                    overflow: unset;
                }
            }
        }

        .layout-button {
            &.expanded {
                .button-icon-after {
                    transform: scaleY(-1);
                }
            }
        }
    }
`;
